import React, { useMemo, useState } from "react";
import {
  formatInrWithoutDecimal,
  formatWithoutDecimal,
} from "../../utils/formatWithoutDecimal";
import { useDashboardValuePrivacy } from "../../hooks/useDashboardValuePrivacy";
import PrivacyBlur from "../PrivacyBlur";

const Pending = ({ className = "", duePayableData }) => {
  const { valuesHidden } = useDashboardValuePrivacy();
  const [activeView, setActiveView] = useState("customer");
  const customerDue = duePayableData?.customer_due || {};
  const vendorPayable = duePayableData?.vendor_payable || {};
  const totalAmount = useMemo(() => {
    if (activeView === "customer") {
      return Number(customerDue?.total_due_amount ?? 0);
    }
    return Number(vendorPayable?.total_payable_amount ?? 0);
  }, [activeView, customerDue, vendorPayable]);
  const statusLabel = activeView === "customer" ? "Due" : "Payable";
  const recordCount =
    activeView === "customer"
      ? Number(customerDue?.total_due_customers ?? 0)
      : Number(vendorPayable?.total_payable_vendors ?? 0);

  return (
    <div className={`col-lg-3 col-md-5 col-12 ${className}`.trim()}>
      <div
        className="card shadow-none h-100 border-0"
        style={{
          minHeight: "92px",
          borderRadius: "18px",
          background: "#FFFFFF",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-3 pb-2">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div style={{ minWidth: 0 }}>
              <span
                className="d-block"
                style={{
                  fontSize: "0.875rem",
                  color: "#334155",
                  fontWeight: 500,
                  letterSpacing: "0.2px",
                }}
              >
                {statusLabel}
              </span>
            </div>
            <div
              className="d-flex align-items-center"
              style={{
                border: "1px solid var(--theme-border, #E2E8F0)",
                borderRadius: "10px",
                overflow: "hidden",
                marginLeft: "auto",
                flexShrink: 0,
                whiteSpace: "nowrap",
              }}
            >
              <button
                type="button"
                onClick={() => setActiveView("customer")}
                style={{
                  border: "none",
                  background:
                    activeView === "customer"
                      ? "var(--theme-primary, #2563EB)"
                      : "var(--theme-card-bg, #FFFFFF)",
                  color:
                    activeView === "customer"
                      ? "var(--theme-background, #FFFFFF)"
                      : "var(--theme-text-secondary, #334155)",
                  fontSize: "0.68rem",
                  fontWeight: 600,
                  padding: "4px 7px",
                  cursor: "pointer",
                  transition: "all 160ms ease",
                  whiteSpace: "nowrap",
                }}
              >
                Customer
              </button>
              <button
                type="button"
                onClick={() => setActiveView("supplier")}
                style={{
                  border: "none",
                  background:
                    activeView === "supplier"
                      ? "var(--theme-primary, #2563EB)"
                      : "var(--theme-card-bg, #FFFFFF)",
                  color:
                    activeView === "supplier"
                      ? "var(--theme-background, #FFFFFF)"
                      : "var(--theme-text-secondary, #334155)",
                  fontSize: "0.68rem",
                  fontWeight: 600,
                  padding: "4px 7px",
                  cursor: "pointer",
                  transition: "all 160ms ease",
                  whiteSpace: "nowrap",
                }}
              >
                Vendor
              </button>
            </div>
          </div>
          <h5
            className="mb-0 mt-2"
            style={{
              fontSize: "1.85rem",
              fontWeight: 700,
              color: "#0F172A",
            }}
          >
            <PrivacyBlur hidden={valuesHidden}>
              {formatInrWithoutDecimal(totalAmount)}
            </PrivacyBlur>
          </h5>

          <div
            className="dashboard-glass-inner"
            style={{
              marginTop: "10px",
              height: "92px",
              borderRadius: "12px",
              background: "#F8FAFC",
              border: "1px solid #E2E8F0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 12px",
            }}
          >
            <div>
              <span
                style={{
                  display: "block",
                  color: "#64748B",
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  marginBottom: "4px",
                }}
              >
                {activeView === "customer"
                  ? "Customer records"
                  : "Vendor records"}
              </span>
              <PrivacyBlur
                hidden={valuesHidden}
                style={{
                  color: "#0F172A",
                  fontSize: "1.1rem",
                  fontWeight: 700,
                }}
              >
                {formatWithoutDecimal(recordCount)}
              </PrivacyBlur>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pending;
